import { TaxProcedure } from '@carvia/ros-client-types';
import { normalizeVatId } from '@/utils/vat-id';

export const REGULAR_TAX_PERCENT = 19;

export function canUseReverseChargeTaxProcedure(
  vatId?: string | null,
  options?: { requireVatId?: boolean },
): boolean {
  if (options?.requireVatId === false) {
    return true;
  }
  return !!normalizeVatId(vatId);
}

export function isNonStandardTaxProcedure(taxProcedure: TaxProcedure): boolean {
  return taxProcedure !== TaxProcedure.REGULAR;
}

export function resolveTaxPercentFromTaxProcedure(taxProcedure: TaxProcedure): number {
  return taxProcedure === TaxProcedure.REGULAR ? REGULAR_TAX_PERCENT : 0;
}

export function resolvePricingTaxPercent(
  taxPercent: number | null | undefined,
  taxProcedure: TaxProcedure,
): number {
  if (isNonStandardTaxProcedure(taxProcedure)) {
    return 0;
  }
  if (taxPercent !== null && taxPercent !== undefined) {
    return taxPercent;
  }
  return resolveTaxPercentFromTaxProcedure(taxProcedure);
}
